export const STORE_SEARCH = 'store-search';
export const DATA_SELECTOR_ID = 'data-selectorid';
export const STORE_CARD = 'store-card';
export const STORE_SEARCH_RESULTS = 'store-search-results';
export const FOCUS_PREDICTION_CLASS = 'js-focus-prediction';
export const KL_HIDDEN_CLASS = 'kl-hidden';
export const KL_VISIBLE_CLASS = 'kl-visible';
export const STORE_LAYER_TITLE_CLASS = 'mc-drawer__title';
export const CONTEXTUALIZATION_LAYER = 'openStoreContextLayer';
export const CONTEXTUALIZATION_LAYER_SEARCH_MODE_EVENT = 'openStoreContextLayerInSearchMode';
export const IS_USER_CONTEXTUALIZED = 'isUserContextualized';
export const customerLocality = {
  customerContextPostcode: '',
  customerContextCity: ''
};
export const storeContextTracking = {
  funnelName: 'standalone'
};
export const storeSearchInfo = {
  productRef: '',
  type: ''
};